async function loadFilteredNews(cat) {
  var formdata = new FormData();
  formdata.append("action", "filter_news");
  if (cat) {
    formdata.append("category", cat);
    // add query string to url
    const params = new URLSearchParams(window.location.search);
    params.set("category", cat);
    window.history.replaceState(
      {},
      "",
      decodeURIComponent(`${window.location.pathname}?${params}`)
    );
  } else {
    // remove query string from url
    window.history.replaceState({}, "", window.location.href.split("?")[0]);
  }

  var requestOptions = {
    method: "POST",
    body: formdata,
    redirect: "follow",
  };

  fetch("/wp/wp-admin/admin-ajax.php", requestOptions)
    .then((response) => response.text())
    .then((result) => {
      document.querySelector(".article-cards").innerHTML = result;
      document.querySelector(".article-cards").classList.remove("loading");
    })
    .catch((error) => console.log("error", error));

  document.querySelector(".article-cards").classList.add("loading");
}

class NewsFilter extends HTMLElement {
  constructor() {
    super();

    this.newsFilters = document.querySelectorAll(".all-news-list__filter-item");

    this.loadNews = this.loadNews.bind(this);

    this.newsFilters.forEach((filter) => {
      filter.addEventListener("click", (e) => {
        this.loadNews(e);
      });
    });

    this.addEventListener("click", (e) => {
      this.classList.toggle("open");
    });
  }

  loadNews(e) {
    e.preventDefault;
    console.log("filter", e.target.dataset.newsCategory);
    loadFilteredNews(e.target.dataset.newsCategory);

    this.newsFilters.forEach((otherFilter) => {
      otherFilter.classList.remove("active");
    });
    e.target.classList.add("active");
  }
}

customElements.define("news-filter", NewsFilter);
